import React, { useState, useEffect } from 'react';
import HeaderAdmin from "../../Components/HeaderAdmin/Header";
import BuildAccordion from './BuildAccordion';
import BuildTab from './BuildTab2';
import { IoClose } from "react-icons/io5";
import { Modal } from "react-bootstrap";
import { MdBookmarkAdd } from "react-icons/md";
import { useParams } from "react-router-dom";
import { getbuildsheet, getbuildsheetdata, addbuildsheet } from "../../Api/buildsheetApi"
import { getsingleStagingStations, upateStagingStationStatus } from "../../Api/StagingStationsApi"
import { getCurrentUser } from "../../Api/auth";
import DriverWood from "./DriverWood";
import Hybrid from "./Hybrid";
import IronWedge from "./IronWedge";
import Wedge from "./Wedge";
import Putter from "./Putter";
import { buildStGet } from '../../Api/buildST';
import { getAllStagingStations } from '../../Api/StagingStationsApi'
import { useHistory } from 'react-router-dom';
import { IoCloseSharp } from "react-icons/io5";
import Spinner from 'react-bootstrap/Spinner';
import { Link } from "react-router-dom";
import BuildTabBuildsheet from './BuildTabBuildsheet';
import { getInventoryByTypeWithShaftAndGrip, getallModeldatabymake, getInventoryByType } from "../../Api/inventoryApi";
import { getremoteInquirydataApi } from "../../Api/iron"
import { getNonEmptyStations } from '../../Api/StagingStationsApi'
import { getsingleprescription } from "../../Api/iron"
import { getPrescription } from "../../Api/prescriptionApis";
import { getorderbyid } from "../../Api/inventoryApi";

const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function StagingStation() {

    const history = useHistory();

    const goBack = () => {
        history.goBack();
    };

    const params = useParams();
    const id = params.id;

    const [scrolled, setScrolled] = useState(false);

    const [show01, setShow01] = useState(false);

    const handleClose01 = () => setShow01(false);
    const handleShow01 = () => setShow01(true);
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [buildsheetdata, setBuildSheetData] = useState([]);
    const [buildsheetnumber, setBuildSheetNumber] = useState(0);
    const [apicall, setApicall] = useState(false);
    const [validated, setValidated] = useState(false);
    const [buildApiCall, setBuildApiCall] = useState(0);
    const [apicallupate, setApicallUpate] = useState(false);
    const [errors, setErrors] = useState([]);
    const [StagingStation, setStagingStation] = useState(0);
    const [userdata, setUserdata] = useState('');
    const [closePopup, setClosePopup] = useState('');

    const [show2, setShow2] = useState(false);

    const handleClose2 = () => setShow2(false);
    const handleShow2 = () => setShow2(true);

    const [show3, setShow3] = useState(false);

    const handleClose3 = () => setShow3(false);
    const handleShow3 = () => setShow3(true);

    const [show4, setShow4] = useState(false);

    const handleClose4 = () => setShow4(false);
    const handleShow4 = () => setShow4(true);

    const [show5, setShow5] = useState(false);

    const handleClose5 = () => setShow5(false);
    const handleShow5 = () => setShow5(true);

    const [show6, setShow6] = useState(false);

    const handleClose6 = () => setShow6(false);
    const handleShow6 = () => setShow6(true);
    const [StagingStations, setStagingStations] = useState([]);

    useEffect(() => {
        getStagingStationdata();
        getDataById();
        getbuildSheetDataById();
        getallModels();
        getRemortFittingDataById();
        buildStGets();
        const getCurrentUserdata = getCurrentUser();
        getNonEmptyStagingStations();
        getallmakedata(0);
        // setUserdata(getCurrentUserdata.user);
        // setUser_id(getCurrentUserdata.user._id);


        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

        getAllStagingStations().then((response) => {
            if (!response.data.status) {
                setErrors(response.data.error);
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setStagingStations(data);
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
        });


        window.scrollTo(0, 0);
    }, []);


    const [selectedButtons, setSelectedButtons] = useState([]);
    const [type_id, setType_id] = useState(0);


    const [buttonNames, setButtonNames] = useState([
        { id: 1, name: "Driver" },
        { id: 2, name: "3 Wood" },
        { id: 2, name: "4 Wood" },
        { id: 2, name: "5 Wood" },
        { id: 2, name: "7 Wood" },
        { id: 2, name: "9 Wood" },
        { id: 3, name: "2 Hybrid" },
        { id: 3, name: "3 Hybrid" },
        { id: 3, name: "4 Hybrid" },
        { id: 3, name: "5 Hybrid" },
        { id: 3, name: "6 Hybrid" },
        { id: 3, name: "7 Hybrid" },
        { id: 3, name: "8 Hybrid" },
        { id: 4, name: "1 Iron" },
        { id: 4, name: "2 Iron" },
        { id: 4, name: "3 Iron" },
        { id: 4, name: "4 Iron" },
        { id: 4, name: "5 Iron" },
        { id: 4, name: "6 Iron" },
        { id: 4, name: "7 Iron" },
        { id: 4, name: "8 Iron" },
        { id: 4, name: "9 Iron" },
        { id: 4, name: "PW" },
        { id: 5, name: "GW" },
        { id: 5, name: "SW" },
        { id: 5, name: "LW" },
        { id: 6, name: "Putter" }
    ]);


    const handleButtonClick = (index, name) => {
        if (selectedButtons.includes(index)) {
            setSelectedButtons(selectedButtons.filter(i => i !== index));
        } else {
            setSelectedButtons([...selectedButtons, index]);
        }

        setButtonNames(buttonNames.filter((_, i) => i !== index));

        const data = {
            builsheetnumber: name,
            project_id: id
        }

        addbuildsheet(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                // handleClose();
                getDataById();
                getbuildSheetDataById();
            }
        }).catch((err) => {
            console.log(err);
        }).finally(() => {
            setApicall(false);
            setValidated(true);
        });
    };

    const [isOpen, setIsOpen] = useState(false);
    const [selectedOption, setSelectedOption] = useState('Assigned');
    const [selectedOptionsId, setselectedOptionsId] = useState('501');
    const [buildstatus2, setBuildstatus2] = useState(false);
    const [selectOptionnumber, setSelectOptionnumber] = useState(0);
    const [makedata, setMakeData] = useState([]);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const closeDropdown = () => {
        setIsOpen(false);
    };

    const selectOption = (option) => {
        setSelectedOption(option.text);
        setselectedOptionsId(option.number);
        setSelectOptionnumber(option.number);
    };


    const [options, setOptions] = useState([
        { text: 'Assigned', color: 'orange', number: 501 },
        { text: 'Ordering', color: 'yellow', number: 502 },
        { text: 'Ready', color: 'green', number: 503 },
    ]);

    const [buildsts, setbuildsts] = useState();

    const buildStGets = () => {
        buildStGet()
            .then((res) => {
                const Data = res.data.data;
                setbuildsts(Data)
            })
            .catch((err) => {
                alert(err);
            });
    }

    useEffect(() => {
        if (StagingStations && Array.isArray(buildsts) && buildsts.length > 0) {
            const stationStatusArray = StagingStations.map(build => Number(build.station_Id));

            const filteredStatusDropdown = buildsts.filter(
                station => !stationStatusArray.includes(Number(station.build_Stations_id))
            );

            const newOptions = filteredStatusDropdown.map(station => ({
                text: station.build_Stations_name,
                number: Number(station.build_Stations_id),
                color: "white"
            }));

            setOptions(prevOptions => [
                { text: 'Assigned', color: 'orange', number: '501' },
                { text: 'Ordering', color: 'yellow', number: '502' },
                { text: 'Ready', color: 'green', number: '503' },
                ...newOptions
            ]);
        }
    }, [buildsts, StagingStations]);


    const getDataById = () => {
        getbuildsheet({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetNumber(Data);
            } else {
                // alert(res.data?.message);
                setBuildSheetNumber([]);
            }
        }).catch((err) => {
            // alert(err);
            console.log(err);
        })
    }

    const getStagingStationdata = () => {
        getsingleStagingStations({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setStagingStation(Data);
                setSelectedOption(Data.build_station_status);
                setselectedOptionsId(Data.build_station_Id);
                setBuildstatus2(Data.build_status);
            } else {
                // alert(res.data?.message); 
                console.log(res.data?.message);

            }
        }).catch((err) => {
            // alert(err);
            console.log(err);
        })
    }

    const getbuildSheetDataById = () => {
        getbuildsheetdata({ id: id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetData(Data);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        if (buildApiCall !== 0) {
            getbuildSheetDataById();
        }
    }, [buildApiCall])


    const handleupateprojectstatus = () => {
        setApicallUpate(true);
        const data = {
            'status': selectedOption,
            'id': StagingStation._id,
            'project_id': params.id,
            "user_id": userdata._id,
            "fitter_name": userdata.firstname + " " + userdata.lastname,

            "station_Id": selectedOptionsId,
            "station_status": selectedOption,
            "status": (selectedOptionsId == 501 || selectedOptionsId == 502 || selectedOptionsId == 503) ? "0" : "1"
        }
        upateStagingStationStatus(data).then((res) => {
            console.log("res", res);
            if (!res.data.status) {
                setErrors(res.data.data);
                // alert(res.data.data[0].detail);
            } else {
                setApicallUpate(false);
                getDataById();
                getStagingStationdata();
                closeDropdown();

                if (selectedOptionsId == 501 || selectedOptionsId == 502 || selectedOptionsId == 503) {
                    window.location.reload();
                } else {
                    // window.location.reload();
                    window.location.href = `/project/buildstation/buildstation-view/${params.id}`;

                }
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const [titleModel, settitleModel] = useState("")

    const handleShowBtn = (index, name) => {

        var showname = "";
        let parts = name.split(" ");
        if (parts.length > 1) {
            showname = parts[1];
        } else {
            showname = parts[0];
        }
        settitleModel(name)
        if (showname === "Driver" || showname === "Wood") {
            handleShow01();
        }

        if (showname === "Hybrid") {
            handleShow3();
        }

        if (showname === "Iron" || showname === "Wedge" || showname === "PW") {
            handleShow4();
        }

        if (showname === "Putter") {
            handleShow6();
        }

        if (showname === "GW" || showname === "SW" || showname === "LW") {
            handleShow5();
        }



        handleClose();
    }

    useEffect(() => {
        if (closePopup === "driver&Wood") {
            handleClose01();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Hybrid") {
            handleClose3();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Iron&Wedge") {
            handleClose4();
            getDataById();
            getbuildSheetDataById();
        }
        if (closePopup === "Wedge") {
            handleClose5();
            getDataById();
            getbuildSheetDataById();
        }

        if (closePopup === "Putter") {
            handleClose6();
            getDataById();
            getbuildSheetDataById();
        }


        setClosePopup('');

    }, [closePopup])


    const getColorClass = () => {
        const selectedColor = options.find(opt => opt.text === selectedOption)?.color;
        return selectedColor ? `${selectedColor}` : 'white';
    };


    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);


    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByTypeWithShaftAndGrip(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setMakeData(data.makeData);
                setShaftData(data.shaftdata);
                setGripData(data.gripdata);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [allmodels, setAllModels] = useState([]);

    const getallModels = () => {
        getallModeldatabymake().then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setAllModels(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }

    const [remortFittingFormData, setRemortFittingFormData] = useState(initData);

    const getRemortFittingDataById = () => {
        getremoteInquirydataApi({ id: id }).then((res) => {
            console.log("aminesh ++", "1");
            if (res?.code === 200) {
                const userData = res.data.data;
                console.log("userData", userData);
                setRemortFittingFormData(userData);
            } else {
                alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    // useEffect(() => {
    // }, [remortFittingFormData]);

    const [nonEmptyStagingStation, setNonEmptyStagingStation] = useState([]);

    const getNonEmptyStagingStations = async () => {
        return getNonEmptyStations()
            .then((response) => {
                if (!response.data.status) {
                    setErrors(response.data.error);

                } else {
                    const Data = response.data.data;
                    setNonEmptyStagingStation(Data);
                }
            }).catch((err) => {
                console.error(err);
            }).finally(() => {
                // Optionally do something finally
            });
    };

    const [allMakeData, setallMakeData] = useState([]);
    const getallmakedata = (id) => {
        const data = {
            type_id: id
        }
        getInventoryByType(data).then((response) => {
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                setallMakeData(data);
            }
        }
        ).catch((err) => {
            console.log(err);
        });
    }


    const [SinglePrescription, setSinglePrescription] = useState(0);
    const getprescriptionDataById = () => {
        getsingleprescription({ project_id: id }).then((res) => {
            if (res?.code === 200) {
                const prescriptionData = res.data.data;
                setSinglePrescription(prescriptionData);
            } else {
                // alert(res.data?.message);
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        getprescriptionDataById();
        getprescriptiondata();
        getorderdata();
    }, []);

    const [prescription, setPrescription] = useState(initialPrescriptionState);
    const [orderData, setOrderData] = useState([]);

    const getprescriptiondata = () => {
        const data = {
            'project_id': id
        }
        getPrescription(data).then((res) => {
            if (!res.data.status) {
                console.log(res.data.data[0].detail);
            } else {
                setPrescription(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    const getorderdata = () => {
        const data = {
            'project_id': id
        }
        getorderbyid(data).then((res) => {
            if (!res.data.status) {
                console.log(res.data.data[0].detail);
            } else {
                setOrderData(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    // const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 100) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);


    return (
        <>
            {
                remortFittingFormData.firstname != "" ? (
                    <>
                        <Modal size="lg" centered show={show} onHide={handleClose} className="card-radius popup-modal-dark add_club_modal">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">Add Club</h3>
                                        <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className='modal-select-btn'>
                                    <div className='select-btn-list'>


                                        {buttonNames.map((item) => (
                                            <div className='select-btn-item' key={item.id}>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btn-select ${selectedButtons.includes(item.id) ? 'selected' : ''}`}
                                                    // onClick={() => handleButtonClick(index, name)}
                                                    onClick={() => {
                                                        handleShowBtn(item.id, item.name)
                                                        getmakedata(item.id);
                                                        setType_id(item.id);
                                                    }
                                                    }
                                                >
                                                    {item.name}
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </Modal.Body>
                        </Modal>


                        <div className="modalfix main-page-body-content-header">
                            <HeaderAdmin />
                        </div>
                        <div className='design_show_mobile'>
                            <div className='fixed-btn'>
                                <button onClick={handleShow} style={{ opacity: selectedOption !== 'Ordering' ? '1' : '0.5' }} disabled={selectedOption !== 'Assigned' && selectedOption !== 'Ordering' && selectedOption !== 'Ready'}>
                                    {/* <button onClick={handleShow}> */}
                                    <svg xmlns="http://www.w3.org/2000/svg" version="1.0" width="64.000000pt" height="64.000000pt" viewBox="0 0 64.000000 64.000000" preserveAspectRatio="xMidYMid meet">
                                        <g transform="translate(0.000000,64.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                                            <path d="M586 628 c-3 -7 -15 -76 -27 -153 -12 -77 -25 -143 -28 -147 -3 -4 -87 11 -186 32 -207 45 -228 47 -274 22 -55 -29 -71 -71 -71 -182 0 -108 15 -145 72 -180 28 -17 51 -20 159 -20 142 0 193 12 252 61 62 51 77 94 118 338 21 124 38 226 36 227 -14 11 -48 13 -51 2z m-301 -367 c124 -27 130 -29 127 -51 -1 -13 -4 -25 -6 -27 -2 -2 -155 29 -253 52 -22 5 -31 33 -16 48 8 9 -3 11 148 -22z m-67 -97 c76 -16 82 -18 76 -38 -4 -12 -8 -23 -10 -25 -2 -2 -44 4 -94 15 -68 13 -89 21 -85 32 3 7 5 18 5 23 0 12 12 12 108 -7z" />
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <div className="dashboard-container d-flex dashboard_light build_box_dashboard_sec inline-btn-dashboard">
                            <div className="main-container">
                                <div className="main-page-body-content">
                                    <div className="main-page-body-content-body">
                                        <div className="main-page-body-content-body-container">
                                            <div className="container-fluid">
                                                <div className="sec-header-new">
                                                    <button type="button" className="btn-header-transparent">
                                                        <div className="border_box_view">
                                                            <div className="border_box_view_inner">
                                                                <div className="box_icon">
                                                                    <svg fill="none" height="64" viewBox="0 0 64 64" width="64" xmlns="http://www.w3.org/2000/svg"><g clip-rule="evenodd" fill="#99ea24" fill-rule="evenodd"><path d="m6.08372 8.06081c1.57579-3.67684 5.19118-6.06081 9.19148-6.06081h25.4496c4.0003 0 7.6157 2.38397 9.1915 6.06081l4.0837 9.52869v11.1718c-2.4315-1.1303-5.142-1.7613-8-1.7613-10.4934 0-19 8.5066-19 19 0 2.858.631 5.5685 1.7613 8h-14.7613c-6.62742 0-12-5.3726-12-12v-24.4105zm9.19148-2.06081c-2.4002 0-4.5694 1.43038-5.5149 3.63648l-2.72722 6.36352h18.96692v-10zm14.7248 0v10h18.9669l-2.7272-6.36351c-.9455-2.20611-3.1147-3.63649-5.5149-3.63649zm-11 37c0-1.1046-.8954-2-2-2h-5c-1.1046 0-2 .8954-2 2s.8954 2 2 2h5c1.1046 0 2-.8954 2-2z" /><path d="m46 30c-8.8366 0-16 7.1634-16 16s7.1634 16 16 16 16-7.1634 16-16-7.1634-16-16-16zm2 10c0-1.1046-.8954-2-2-2s-2 .8954-2 2v6.5c0 1.1046.8954 2 2 2h6.5c1.1046 0 2-.8954 2-2s-.8954-2-2-2h-4.5z" /></g></svg>
                                                                </div>
                                                                <div className="box_text_content">
                                                                    {/* <div className="big_text">{StagingStation.station_status}</div> */}
                                                                    <div className="big_text">Staging Station {StagingStation.station_Id}</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </button>
                                                    <div className="header-left">
                                                        <Link to={`/project/project-view/${params.id}`}>
                                                            <button type="button" className="btn-header-transparent me-3">
                                                                <div className="border_box_view">
                                                                    <div className="border_box_view_inner">
                                                                        <div className="box_icon">
                                                                            <svg xmlns="http://www.w3.org/2000/svg" clip-rule="evenodd" fill-rule="evenodd" height="512" stroke-linejoin="round" stroke-miterlimit="2" viewBox="0 0 24 24" width="512"><g id="Icon" fill='#99ea24'><path d="m15.479 22.75h-11.479c-.729 0-1.429-.29-1.945-.805-.515-.516-.805-1.216-.805-1.945v-16c0-.729.29-1.429.805-1.945.516-.515 1.216-.805 1.945-.805h8.586c.464 0 .909.184 1.237.513l4.414 4.414c.329.328.513.773.513 1.237v4.151c-.687-.101-1.386-.084-2.068.05-.575.112-1.055.505-1.28 1.046l-.17.41c-.224-.029-.441-.057-.441-.057-.581-.076-1.161.143-1.546.585-.521.598-.922 1.291-1.179 2.042-.19.554-.09 1.166.266 1.631l.271.353c-.137.179-.271.353-.271.353-.356.465-.456 1.077-.266 1.631.257.751.658 1.444 1.179 2.042.385.442.965.661 1.546.585l.441-.057c.086.208.17.41.17.41.023.055.049.109.077.161zm-9.979-8h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75zm7-11.75v3.5c0 .552.448 1 1 1h3.5zm-7 8.25h8c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-8c-.414 0-.75.336-.75.75s.336.75.75.75zm0 7h4.5c.414 0 .75-.336.75-.75s-.336-.75-.75-.75h-4.5c-.414 0-.75.336-.75.75s.336.75.75.75z" /><path d="m19.396 13.044s.355.855.354.855c.135.068.266.144.393.226l.918-.12c.248-.032.497.062.662.251.436.5.771 1.081.987 1.709.081.237.038.5-.115.699 0 0-.562.735-.562.734.008.151.008.303 0 .453l.562.735c.153.199.196.462.115.699-.216.628-.551 1.209-.987 1.709-.165.189-.414.283-.662.251 0 0-.918-.12-.917-.121-.127.083-.259.159-.393.227l-.355.855c-.096.232-.302.4-.548.448-.652.128-1.322.128-1.974 0-.246-.048-.452-.216-.548-.448 0 0-.355-.855-.354-.855-.135-.068-.267-.144-.393-.226l-.918.12c-.249.032-.497-.062-.662-.251-.437-.5-.772-1.081-.987-1.709-.081-.237-.038-.5.114-.699 0 0 .563-.735.563-.734-.008-.151-.008-.303 0-.453l-.563-.735c-.152-.199-.195-.462-.114-.699.215-.628.55-1.209.987-1.709.165-.189.413-.283.662-.251 0 0 .918.12.917.121.127-.083.258-.159.393-.227l.355-.855c.096-.232.302-.4.548-.448.652-.128 1.322-.128 1.974 0 .246.048.452.216.548.448zm-1.535 3.081c-.828 0-1.5.672-1.5 1.5s.672 1.5 1.5 1.5 1.5-.672 1.5-1.5-.672-1.5-1.5-1.5z" /></g></svg>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </button>
                                                        </Link>
                                                        <button type="button" className="btn-header-transparent close-icon" onClick={goBack}>
                                                            <div className="border_box_view">
                                                                <div className="border_box_view_inner">
                                                                    <div className="box_icon">
                                                                        <IoCloseSharp />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </button>
                                                    </div>
                                                </div>
                                                {/* <div className="sec-dashboard-header-title">
                                        <div className="box-title mb-0" style={{ color: '#ffffff' }}>
                                            <h3>Staging Station {getStagingStationNumber(StagingStation.station_name)}</h3>
                                        </div>
                                    </div> */}
                                                <div className="dashboard-sec">
                                                    <div className="row">
                                                        <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open db_col design_hide_mobile">
                                                            {/* <div className="build_number_box">
                                                    <div className="build_number_box_inner">
                                                        <div className="build_title">
                                                            Build Number
                                                        </div>
                                                        <div className="build_number">
                                                            {buildsheetnumber?.number || 0}
                                                        </div>
                                                    </div>
                                                </div> */}
                                                            <BuildAccordion buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} selectedOptions={selectedOption} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                                            {/* <div className="btn-box-section btn-inline-box">
                                                                <button className="btn btn-primary btn-remove">Remove Staging Station</button> 
                                                            </div> */}
                                                        </div>
                                                        <div className={`col-lg-4 col-md-12 col-sm-12 order-md-1 order-sm-1 order-1 dashboard_first right_fix_sec ${scrolled ? 'tab_fix' : ''}`}>
                                                            <div className="fix_sec_view container-fluid ps-0">
                                                                <div className="btn-box-section mt-0 design_hide_mobile">
                                                                    <button className="btn btn-primary btn-create" onClick={handleShow} disabled={selectedOption !== 'Assigned' && selectedOption !== 'Ordering' && selectedOption !== 'Ready'} >Add Club</button>
                                                                    {/* <button className="btn btn-primary btn-create" onClick={handleShow}  >Add Club</button> */}
                                                                </div>
                                                                <div className='select-dropdown-build'>
                                                                    <div className={`select-options-dropdown ${isOpen ? 'open' : ''}`}>
                                                                        {/* <div className='select-option-inner' onClick={toggleDropdown}> */}
                                                                        <div className='select-option-inner' onClick={!buildstatus2 ? toggleDropdown : null}>
                                                                            <div className='select-options-icon'>
                                                                                <span className={`icon-color color-${getColorClass()}`}>{selectedOptionsId == '501' || selectedOptionsId == '502' || selectedOptionsId == '503' ? '' : selectedOptionsId}</span>
                                                                            </div>
                                                                            <div className='selected-option-text'>{selectedOption}</div>
                                                                            <span className={`icon ${isOpen ? 'up' : 'down'}`}>
                                                                                <i className="bi bi-chevron-down" />
                                                                            </span>
                                                                        </div>

                                                                        {isOpen && (
                                                                            <div className='option-list buildsheet-option-list'>
                                                                                <div className='drop-down-list'>
                                                                                    {options.map(option => (
                                                                                        <div
                                                                                            key={option.number}
                                                                                            className={`drop-down-item ${selectOptionnumber === option.number ? 'active' : ''}`}
                                                                                            onClick={() => selectOption(option)}
                                                                                        >
                                                                                            <div className='drop-down-item-icon'>
                                                                                                <span className={`icon-color color-${option.color}`}>{option.number == '501' || option.number == '502' || option.number == '503' ? '' : option.number}</span>
                                                                                            </div>
                                                                                            <div className='drop-down-item-text'>{option.text}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                                <div className='form-box-section'>
                                                                                    {
                                                                                        selectedOptionsId == 501 ? (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                disabled
                                                                                            >
                                                                                                <span>Update Status</span>
                                                                                            </button>
                                                                                        ) : (
                                                                                            <button
                                                                                                className="btn btn-primary btn-create"
                                                                                                // onClick={closeDropdown}
                                                                                                onClick={() => {
                                                                                                    // closeDropdown()
                                                                                                    handleupateprojectstatus();
                                                                                                }}
                                                                                            >
                                                                                                {apicallupate ? (<Spinner animation="border" className="border-black" />) : (<span>Update Status</span>)}
                                                                                            </button>
                                                                                        )
                                                                                    }

                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                {
                                                                    allMakeData && allMakeData.length > 0 ? (
                                                                        <>
                                                                            <div className="design_hide_mobile">
                                                                                <BuildTab project_id={id} project_step="buildsheet" allmodels={allmodels} remortFittingFormData={remortFittingFormData} allMakeData={allMakeData} SinglePrescription={SinglePrescription} prescriptioncalc={prescription} orderData={orderData} additemstatus={selectedOption} />
                                                                            </div>
                                                                            <div className='design_show_mobile'>
                                                                                <BuildTabBuildsheet project_id={id} project_step="buildsheet" currentpagename="buildsheet" buildsheets={buildsheetdata} ondeleteChange={(deleteid) => setBuildApiCall(deleteid)} allmodels={allmodels} StagingStations={StagingStations} remortFittingFormData={remortFittingFormData} nonEmptyStagingStation={nonEmptyStagingStation} allMakeData={allMakeData} prescriptioncalc={prescription} buildsheetnumber={buildsheetnumber} orderData={orderData} additemstatus={selectedOption} />
                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <></>
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        {/* Driver + Wood Modal Start Here */}
                        <Modal size="lg" show={show01} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose01} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <DriverWood project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Driver + Wood Modal End Here  */}

                        {/* Hybrid Modal Start Here */}
                        <Modal size="lg" show={show3} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose3} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Hybrid project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Hybrid Modal End Here  */}

                        {/* Iron + Wedge Start Here */}
                        <Modal size="lg" show={show4} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose4} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <IronWedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Iron + Wedge End Here  */}

                        {/* Wedge Start Here */}
                        <Modal size="lg" show={show5} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose5} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Wedge project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Wedge End Here  */}

                        {/* Putter Start Here */}
                        <Modal size="lg" show={show6} id="success_tic" centered className="card-radius popup-modal-dark add_club_modal build_sheet_modal unique m-0">
                            <Modal.Body className="bg_dark_black card-dark card-radius dark_modal_mobile">
                                <div className="close-modal">
                                    <div className="custom-modal-header">
                                        <h3 className="text mb-5">{titleModel}</h3>
                                        <button type="button" className="btn-close" onClick={handleClose6} aria-label="Close">
                                            <IoClose />
                                        </button>
                                    </div>
                                </div>
                                <div className="modal-long-form">
                                    <Putter project_id={id} title={titleModel} user_id={userdata._id} fitter_name={userdata.firstname + " " + userdata.lastname} ondeleteChange={(closetstatus) => setClosePopup(closetstatus)} makedata={makedata} type_id={type_id} shaftdata={shaftdata} gripdata={gripdata} allmodels={allmodels} remortFittingFormData={remortFittingFormData}/>
                                </div>
                            </Modal.Body>
                        </Modal>
                        {/* Putter End Here  */}
                        <style>
                            {
                                `
                                .unique .modal-dialog{
                                    max-width: 100% !important;
                                     width: 100% !important;
                                }
                                `
                            }
                        </style>
                    </>) : (<> </>)
            }
        </>
    );
}

function getStagingStationNumber(stationName) {
    switch (stationName) {
        case "Staging Station":
            return 1;
        case "Staging Station1":
            return 2;
        case "Staging Station2":
            return 3;
        case "Staging Station3":
            return 4;
        default:
            return 0; // or handle other cases as needed
    }
}
export default StagingStation;